import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { AddOrUpdateInvoiceBuyOrder, AddOrUpdateInvoiceBuyOrderResponse, InvoiceBuyOrderDTO } from '../interface/buy-order.interface';

@Injectable({
  providedIn: 'root',
})
export class InvoiceBuyOrdersService {

  constructor(private httpClient: HttpClient) { }
  getInvoiceBuyOrder(invoiceId: number): Observable<InvoiceBuyOrderDTO> {
    const endpoint = `${environment.apiUrl}/BuyOrders/Invoice/${invoiceId}`;
    return this.httpClient.get<InvoiceBuyOrderDTO>(endpoint);
  }

  addOrUpdateInvoiceBuyOrder(invoiceId: number ,request: AddOrUpdateInvoiceBuyOrder) {
    const endpoint = `${environment.apiUrl}/BuyOrders/Invoice/${invoiceId}`;
    const formData = new FormData();
    formData.append('InvoiceId', request.invoiceId.toString());
    formData.append('Code', request.code);
    formData.append('FechaEmision', request.fechaEmision);
    formData.append('Amount', request.amount.toString());
    formData.append('Plazo', request.plazo.toString());
    formData.append('Sigfe', String(request.sigfe));
    if(request.document != null) {
      formData.append('Document', request.document);
    }
    return this.httpClient.post<AddOrUpdateInvoiceBuyOrderResponse>(endpoint, formData);
  }
}
